import { enGB, fi, is } from 'date-fns/locale';
import type { Locale } from 'date-fns';

export const dateFnsLocaleToImportMap: Record<string, Locale> = {
  // Why this exists:
  // Using `toLocaleString` can produce different date formats
  // on the server (Node) vs. the client (browser).
  // This leads to hydration mismatches in React.

  // Solution:
  // For certain locales, we force formatting through date-fns
  // to guarantee consistent output on both server and client.

  // Reference: https://lastminute.atlassian.net/browse/SLIDERS-1591

  // LOCALES USING DATE-FNS (to prevent mismatches):
  'en-GB': enGB,
  'fi-FI': fi,
  'is-IS': is,

  // OTHER LOCALES:
  // 'it-IT': it,
  // 'da-DK': da,
  // 'hu-HU': hu,
  // 'ro-RO': ro,
  // 'pl-PL': pl,
  // 'pt-PT': pt,
  // 'sv-SE': sv,
  // 'cs-CZ': cs,
  // 'sk-SK': sk,
  // 'et-EE': et,
  // 'nl-NL': nl,
  // 'lv-LV': lv,
  // 'lt-LT': lt,
  // 'bg-BG': bg,
  // 'sl-SI': sl,
  // 'hr-HR': hr,
  // 'el-GR': el,
  // 'en-US': enUS,
  // 'es-ES': es,
  // 'en-CA': enCA,
  // 'fr-FR': fr,
  // 'de-DE': de,
  // 'fr-CA': frCA,
};

const normalizeLocaleCode = (locale: string) => locale.replace(/_/g, '-');

export const getDateFnsLocaleByCode = (locale: string) => dateFnsLocaleToImportMap[normalizeLocaleCode(locale)] || null;

export const localesWithSSRMismatchBetweenServerAndClient = (locale: string) =>
  !!dateFnsLocaleToImportMap[normalizeLocaleCode(locale)];
